<template>
  <div class="ex-breadcrumb">
    <h2>{{ title }}</h2>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/Breadcrumb.vue